import React, { Component } from 'react'
import EntityList from './../../components/entityList';

class Waranties extends Component {
  render() {
    return (
      <EntityList apiRoute='api/waranties' title='Remorque - Garanties' editTitle='Garantie' displayColumns={[
        {Description: 'Description', Column: 'Description'},
        {Description: 'Inactif', Column: 'Inactive', sortable: false, format: {type: 'boolean'}}
      ]}/>
    )
  }
}

export default Waranties;


/** WEBPACK FOOTER **
 ** ./src/app/routes/trailers/waranties.js
 **/